import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Chip, Typography } from '@mui/material';

import TableInc from '../../shared-ui/TableInc';
import BoxInc from '../../shared-ui/BoxInc/Index';
import SkeletonWrapper from '../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import { hasAuthourity } from '../../lib/access.es6';
import {
  getLookupListTypesRequest,
  getLookupListRequest,
  addLookupListItemRequest,
  updateLookupListItemRequest,
  deleteLookupListItemRequest,
} from './actions.es6';

var COLUMNS = [
  { title: 'Value (ID)', field: 'value', editable: 'onAdd' },
  { title: 'Display Name', field: 'name' },
  {
    title: 'Active',
    field: 'active',
    lookup: { true: 'Yes', false: 'No' },
    render: function(rowData) {
      return rowData.active
        ? <Chip label="Active" sx={{ bgcolor: '#75A85E', color: '#fff' }} />
        : <Chip label="Inactive" sx={{ bgcolor: '#d32f2f', color: '#fff' }} />;
    }
  },
];

// Policies keep the codes they were captured with, so these lists can only
// be deactivated, never deleted.
var NO_DELETE_LIST_TYPES = ['worksites'];

function toLabel(listType) {
  return listType
    .split('-')
    .map(function(word) { return word.charAt(0).toUpperCase() + word.slice(1); })
    .join(' ');
}

export function CoverLinkSettings(props) {
  var [activeTab, setActiveTab] = useState(0);

  var listTypes = props.settingsData.listTypes || [];
  var listTypesLoader = props.settingsData.listTypesLoader;

  useEffect(function() {
    props.dispatch(getLookupListTypesRequest());
  }, []);

  useEffect(function() {
    if (listTypes.length > 0) {
      props.dispatch(getLookupListRequest(listTypes[activeTab]));
    }
  }, [activeTab, listTypes.length]);

  function handleTabChange(event, newValue) {
    setActiveTab(newValue);
  }

  var currentListType = listTypes[activeTab];
  var data = currentListType && props.settingsData.lists[currentListType] ? props.settingsData.lists[currentListType] : [];
  var loading = currentListType && props.settingsData.listsLoader[currentListType];
  var canManage = hasAuthourity('MANAGE_LOOKUP_LISTS');
  var canDelete = NO_DELETE_LIST_TYPES.indexOf(currentListType) === -1;

  return (
    <React.Fragment>
      <CssBaseline />
      <BoxInc
        expanded
        title="Lookup List Settings"
        hasPermision={hasAuthourity('INTERNAL_DASHBOARD') || canManage}
        actionButtons={[]}
      >
        {listTypesLoader && <SkeletonWrapper loading={listTypesLoader} />}

        {!listTypesLoader && listTypes.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
            No lookup lists configured for this partner.
          </Typography>
        )}

        {!listTypesLoader && listTypes.length > 0 && (
          <React.Fragment>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
              <Tabs value={activeTab} onChange={handleTabChange}>
                {listTypes.map(function(listType) {
                  return <Tab key={listType} label={toLabel(listType)} />;
                })}
              </Tabs>
            </Box>

            {loading
              ? <SkeletonWrapper loading={loading} />
              : <TableInc
                  columns={COLUMNS}
                  data={data}
                  options={{
                    pageSize: 20,
                    pageSizeOptions: [20, 50, 100],
                    search: true,
                    showTitle: false,
                    actionsColumnIndex: -1,
                    addRowPosition: 'first',
                  }}
                  editable={!canManage ? undefined : {
                    onRowAdd: function(newData) {
                      return new Promise(function(resolve) {
                        var item = {
                          value: newData.value,
                          name: newData.name,
                          active: newData.active === 'true' || newData.active === true,
                        };
                        props.dispatch(addLookupListItemRequest(currentListType, item));
                        resolve();
                      });
                    },
                    onRowUpdate: function(newData, oldData) {
                      return new Promise(function(resolve) {
                        var patch = {
                          name: newData.name,
                          active: newData.active === 'true' || newData.active === true,
                        };
                        props.dispatch(updateLookupListItemRequest(currentListType, oldData.value, patch));
                        resolve();
                      });
                    },
                    onRowDelete: !canDelete ? undefined : function(oldData) {
                      return new Promise(function(resolve) {
                        props.dispatch(deleteLookupListItemRequest(currentListType, oldData.value));
                        resolve();
                      });
                    },
                  }}
                />
            }
          </React.Fragment>
        )}
      </BoxInc>
    </React.Fragment>
  );
}

export default connect(function(state) {
  return {
    settingsData: state.coverLinkSettings,
    globalData: state.global,
  };
})(CoverLinkSettings);
